import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Router } from "@angular/router";
import { Task } from "../theme/layouts/header-nav/header-nav.component";

@Injectable()
export class taskService {
    constructor(private http: HttpClient, private router: Router) {

    }

    AddTask(data: any): Observable<Task> {
        return this.http.post<Task>("https://localhost:44372/api/values", data);
    }

    FetchAllTask(): Observable<Task> {
        return this.http.get<Task>("https://localhost:44372/api/values");
    }

    FetchTaskById(id: any): Observable<any> {
        return this.http.get<any>("https://localhost:44372/api/values", id);
    }

    UpdateTask(id: any): Observable<any> {
        return this.http.put<any>("https://localhost:44372/api/values", id);
    }

    DeleteTask(id: any): Observable<any> {
        return this.http.delete<any>("https://localhost:44372/api/values", id);
    }

}